import {
  GeneralButtonActionEvent,
  Screen,
  trackEvent,
  UIElementID,
  UIInteractionType,
} from '@otter-ai/telemetry';

export const trackOtterAPIMain = {
  clickAPIKey: () => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.otterAPIKey,
        UIInteractionType: UIInteractionType.primaryActivate,
      }),
    );
  },

  clickViewAPIDocs: () => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.otterViewAPIDocs,
        UIInteractionType: UIInteractionType.primaryActivate,
      }),
    );
  },
} as const;

export const trackOtterAPI = {
  main: trackOtterAPIMain,
} as const;
